import './archive.css';

import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { userConfigState } from '../../recoil/atoms/userConfigState';


import { translate } from '../../../common/language/translations';
import { ReportHistoryLinePlot } from '../../components/plots/ReportHistoryLinePlot';
import { PlayerReport } from '../../types/report';
import { getTenantColor } from '../../static/tenantConfigs';


interface ReportStatisticsProps {
  allReports: PlayerReport[];
  reports: PlayerReport[];
}


export const ReportStatistics: React.FC<ReportStatisticsProps> = ({
  allReports,
  reports,
}) => {

  const userConfig = useRecoilValue(userConfigState);
  const tenantColor = getTenantColor(userConfig?.club ?? '');

  const [totalNumberOfReports, setTotalNumberOfReports] = useState<number | undefined>(undefined);
  const [numberOfReportsThisYear, setNumberOfReportsThisYear] = useState<number | undefined>(undefined);
  const [numberOfReportsLastMonth, setNumberOfReportsLastMonth] = useState<number | undefined>(undefined);


  useEffect(() => {
    let totalReports = 0;
    let reportsThisYear = 0;
    let reportsLastMonth = 0;

    reports.forEach((report: PlayerReport) => {
      totalReports += 1;

      const reportDate = new Date(report.date);
      const currentDate = new Date();
      const thisYear = currentDate.getFullYear();
      const thirtyDaysAgo = new Date(currentDate.setDate(currentDate.getDate() - 30));
      if (reportDate.getFullYear() === thisYear) {
        reportsThisYear += 1;
      }
      if (reportDate >= thirtyDaysAgo) {
        reportsLastMonth += 1;
      }
    });

    setTotalNumberOfReports(totalReports);
    setNumberOfReportsThisYear(reportsThisYear);
    setNumberOfReportsLastMonth(reportsLastMonth);
  }, [reports]);


  return (
    <div className='archive-report-statistics-container'>

      {totalNumberOfReports !== undefined && numberOfReportsThisYear !== undefined && numberOfReportsLastMonth !== undefined && (
        <div className='archive-report-statistics-section fade-in'>
          <div className='archive-report-statistics-summary-row'>
            <div className='archive-report-statistics-summary-entry'>
              <div className='archive-report-statistics-summary-entry-title'>
                {translate('totalNumberOfReports', userConfig?.language)}
              </div>
              <div className='archive-report-statistics-summary-entry-value'>
                {totalNumberOfReports}
              </div>
            </div>

            <div className='archive-report-statistics-summary-entry'>
              <div className='archive-report-statistics-summary-entry-title'>
                {translate('numberOfReportsThisYear', userConfig?.language)}
              </div>
              <div className='archive-report-statistics-summary-entry-value'>
                {numberOfReportsThisYear}
              </div>
            </div>

            <div className='archive-report-statistics-summary-entry'>
              <div className='archive-report-statistics-summary-entry-title'>
                {translate('numberOfReportsLastMonth', userConfig?.language)}
              </div>
              <div className='archive-report-statistics-summary-entry-value'>
                {numberOfReportsLastMonth}
              </div>
            </div>
          </div>

          <div className='archive-report-statistics-label'>
            <div className='archive-report-statistics-label-line' style={{ backgroundColor: tenantColor }} />

            <div className='archive-report-statistics-label-text'>
              {translate('numberOfReportsPerMonth', userConfig?.language)}
            </div>
          </div>

          <div className='archive-report-statistics-line-plot-container'>
            <ReportHistoryLinePlot
              allReports={allReports}
              reports={reports}
              tenantColor={tenantColor}
              language={userConfig?.language ?? 'en'}
            />
          </div>
        </div>
      )}

    </div>
  );
};
